import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyTheme, readTheme } from "./theme";
import "./styles.css";

// Applied before React mounts. Doing it in a component instead lets the
// browser paint one frame in the wrong theme first — a white flash on every
// load for anyone using dark, which is the most visible bug a theme system
// can have.
applyTheme(readTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
